import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-LDD2PL42CY";

export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const trackClick = (action, category = 'User') => {
  console.log(`Tracking click: ${action}`);
  ReactGA.event({ category, action });
};


// <!-- Google tag (gtag.js) -->
// <script async src="https://www.googletagmanager.com/gtag/js?id=G-LDD2PL42CY"></script>
// <script>
//   window.dataLayer = window.dataLayer || [];
//   function gtag(){dataLayer.push(arguments);}
//   gtag('js', new Date());

//   gtag('config', 'G-LDD2PL42CY');
// </script>